import { useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { SIZE_CLIENTS_PAGE } from 'const/paging';
import { headerTabUser, TabUser, User } from './type';
import { usePaging } from 'hooks/usePaging';
import { adminGetUser } from 'services/admin';
import { getClients } from 'services/clients';
import { SelectOptions } from '../../components/elements/InputSelect';
import { Client } from 'types/clients';

const userPageSize = 20;
export const useInjection = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [clientAccess, setClientAccess] = useState<User[]>([]);
  const [optionClient, setOptionClient] = useState<SelectOptions[]>([]);
  const [fieldAccess, setFieldAccess] = useState<User[]>([]);
  const handleChangeTab = useCallback(
    (newValue: number) => {
      const nameTab = headerTabUser.find((item) => item.value === newValue)?.param;
      setSearchParams({ tab: nameTab || TabUser.CLIENT });
    },
    [setSearchParams]
  );
  const {
    pagingInfo: pagingInfoClient,
    setCurrentPage: setCurrentPageClient,
    setTotal: totalClient
  } = usePaging({
    rowsPerPage: userPageSize
  });

  const {
    pagingInfo: pagingInfoField,
    setCurrentPage: setCurrentPageField,
    setTotal: totalField
  } = usePaging({
    rowsPerPage: userPageSize
  });

  const [page, setPage] = useState<{
    clients: number;
    field: number;
  }>({ clients: 1, field: 1 });
  const [sortBy, setSortBy] = useState<{
    clients: string;
    field: string;
  }>({ clients: '', field: '' });
  const [order, setOrder] = useState<{
    clients: 'desc' | 'asc' | undefined;
    field: 'desc' | 'asc' | undefined;
  }>({
    clients: undefined,
    field: undefined
  });
  const [searchText, setSearchText] = useState<{
    clients: string;
    field: string;
  }>({
    clients: '',
    field: ''
  });

  const handleSort = useCallback(
    (orderBy: string) => {
      const key = (searchParams.get('tab') || 'clients') as 'clients' | 'field';
      const sortByNow = sortBy[key];
      const orderNow = order[key];
      if (orderBy === sortByNow) {
        if (orderNow === 'asc') {
          setOrder((prevState) => ({ ...prevState, [key]: 'desc' }));
        } else {
          setOrder((prevState) => ({ ...prevState, [key]: 'asc' }));
        }
      } else {
        setSortBy((prevState) => ({ ...prevState, [key]: orderBy }));
        setOrder((prevState) => ({ ...prevState, [key]: 'asc' }));
      }
    },
    [searchParams, sortBy, order]
  );

  const handleChangePage = useCallback(
    (value: number) => {
      const key = (searchParams.get('tab') || 'clients') as 'clients' | 'field';
      if (key === TabUser.FIELDS) {
        setCurrentPageField(value);
      } else {
        setCurrentPageClient(value);
      }
      setPage((prevState) => ({ ...prevState, [key]: value }));
    },
    [searchParams, setCurrentPageClient, setCurrentPageField]
  );
  const onSearch = useCallback(
    (value: string) => {
      const key = (searchParams.get('tab') || 'clients') as 'clients' | 'field';
      setSearchText((prevState) => ({ ...prevState, [key]: value }));
    },
    [searchParams]
  );

  const getDataClient = useCallback(async () => {
    const params = {
      size: SIZE_CLIENTS_PAGE,
      page: page.clients,
      keyword: searchText?.clients || undefined,
      orderBy: sortBy?.clients || undefined,
      order: order?.clients || undefined
    };
    const data = await adminGetUser(params);
    setClientAccess(data.users);
    totalClient(data.total);
  }, [order?.clients, page.clients, searchText?.clients, sortBy?.clients, totalClient]);

  const getDataField = useCallback(async () => {
    // const params = {
    //   size: SIZE_CLIENTS_PAGE,
    //   page: page.field,
    //   keyword: searchText?.field || undefined,
    //   sortBy: sortBy?.field || undefined,
    //   order: order?.field || undefined
    // };
    // const data = await getClients(params);
    setFieldAccess([]);
  }, []);

  const sortOption = useMemo(() => {
    const key = (searchParams.get('tab') || 'clients') as 'clients' | 'field';
    return {
      field: sortBy[key],
      order: order[key]
    };
  }, [order, searchParams, sortBy]);
  useEffect(() => {
    getDataClient();
  }, [order?.clients, page.clients, searchText?.clients, sortBy?.clients, getDataClient]);
  useEffect(() => {
    getDataField();
  }, [getDataField]);

  const getClientByAdmin = useCallback(async () => {
    const data = await getClients({});
    const clients = data.clients as Client[];
    setOptionClient(
      clients?.map((item) => ({
        value: String(item.id),
        label: item.clientName
      }))
    );
  }, []);

  useEffect(() => {
    getClientByAdmin();
  }, [getClientByAdmin]);

  return {
    onSearch,
    pagingInfoField,
    pagingInfoClient,
    handleChangePage,
    handleChangeTab,
    searchParams,
    clientAccess,
    totalField,
    fieldAccess,
    getDataClient,
    searchText,
    optionClient,
    handleSort,
    sortOption,
    handleRefreshDataClient: getDataClient,
    tab: headerTabUser.find((item) => item.param === searchParams.get('tab'))?.value || 0
  };
};
